<template src="./customer.html"></template>

<script>
  import axios from 'axios'
  import ContactSelect from '../../ContactSelect.vue'

  function emptyCreateForm () {
    return {
      company: '',
      email: '',
      phone: '',
      mobile: ''
    }
  }

  export default {
    name: 'customer',
    components: { 'contact-select': ContactSelect },
    props: {
      parent_quote: {
        type: Object
      },
      duplicate: {
        type: Boolean,
        default: false
      },
      /** Custom label for the primary action button. Falls back to "Duplicate Quote" / "Start Quote". */
      submitLabel: {
        type: String,
        default: ''
      }
    },
    data: function () {
      return {
        mode: 'search',
        contact: null,
        contacts: [],
        contactSearchLoading: false,
        serviceM8Jobs: [],
        serviceM8Job: null,
        serviceM8Loading: false,
        submitting: false,
        createForm: emptyCreateForm(),
        createErrors: {},
        createFormError: '',
        createSaving: false
      }
    },
    computed: {
      sm8JobSelectItems: function () {
        return (this.serviceM8Jobs || []).map((job) => ({
          id: job.uuid,
          name: this.sm8JobDisplay(job)
        }))
      },
      serviceM8JobUuid: function () {
        return this.serviceM8Job && this.serviceM8Job.uuid ? this.serviceM8Job.uuid : ''
      }
    },
    methods: {
      sm8JobDisplay: function (job) {
        if (!job) return ''
        return '#' + (job.generated_job_id || '') + (job.job_description ? ' — ' + job.job_description : '')
      },
      /** Allow parent to re-enable the button after a failed submit. */
      resetSubmitting: function () {
        this.submitting = false
      },
      onContactInput: function (value) {
        this.contact = value
        if (!value) {
          this.serviceM8Jobs = []
          this.serviceM8Job = null
        }
      },
      onSm8JobSelected: function (payload) {
        const id = payload && payload.id != null ? String(payload.id) : ''
        this.serviceM8Job = id
          ? (this.serviceM8Jobs.find(j => String(j.uuid) === id) || null)
          : null
      },
      start: function () {
        if (this.submitting) return
        if (!this.contact || !this.contact.id) return
        this.submitting = true
        if (this.duplicate) {
          return this.$emit('duplicate', { contact: this.contact, service_m8_job: this.serviceM8Job })
        }
        this.$emit('start', { contact: this.contact, service_m8_job: this.serviceM8Job })
      },
      onContactSearch: function (searchText) {
        if (searchText && searchText.trim().length >= 2) {
          this.contactSearchLoading = true
          axios.post('/api/contact/fetch/search', { text: searchText.trim() }).then(response => {
            this.contacts = response.data.contacts || response.data || []
          }).catch(() => {
            this.contacts = []
          }).finally(() => {
            this.contactSearchLoading = false
          })
        } else {
          this.contacts = []
        }
      },
      fetchSm8Jobs: function () {
        if (!this.contact || !this.contact.service_m8_uuid) {
          this.serviceM8Jobs = []
          this.serviceM8Job = null
          return
        }
        this.serviceM8Loading = true
        axios.get(`/api/integrations/servicem8/jobs/contact/${this.contact.id}`)
          .then(response => {
            this.serviceM8Jobs = response.data.data || []
            const linkedUuid = this.parent_quote && this.parent_quote.service_m8_job_id
            this.serviceM8Job = linkedUuid
              ? (this.serviceM8Jobs.find(j => j.uuid === linkedUuid) || null)
              : null
          })
          .catch(() => {
            this.serviceM8Jobs = []
            this.serviceM8Job = null
          })
          .finally(() => {
            this.serviceM8Loading = false
          })
      },
      enterCreateMode: function () {
        this.mode = 'create'
        this.createForm = emptyCreateForm()
        this.createErrors = {}
        this.createFormError = ''
      },
      exitCreateMode: function () {
        this.mode = 'search'
        this.createErrors = {}
        this.createFormError = ''
      },
      onCreateField: function (field, value) {
        this.$set(this.createForm, field, value)
        if (this.createErrors[field]) {
          this.$set(this.createErrors, field, '')
        }
        this.createFormError = ''
      },
      validateCreateForm: function () {
        const errors = {}
        const company = (this.createForm.company || '').trim()
        const email = (this.createForm.email || '').trim()
        if (!company) errors.company = 'Customer name is required'
        if (!email) errors.email = 'Email address is required'
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = 'Enter a valid email address'
        this.createErrors = errors
        return Object.keys(errors).length === 0
      },
      saveNewCustomer: function () {
        if (this.createSaving) return
        if (!this.validateCreateForm()) return
        this.createSaving = true
        this.createFormError = ''
        const payload = {
          company: this.createForm.company.trim(),
          email: this.createForm.email.trim(),
          phone: (this.createForm.phone || '').trim() || null,
          mobile: (this.createForm.mobile || '').trim() || null,
          first_name: '',
          last_name: ''
        }
        axios.post('/api/contact', payload)
          .then((response) => {
            const created = (response.data && (response.data.contact || response.data.data)) || null
            if (!created || !created.id) {
              this.createFormError = 'Customer was created but could not be selected. Search for them to continue.'
              this.mode = 'search'
              return
            }
            this.contact = created
            this.contacts = [created]
            this.mode = 'search'
            this.createForm = emptyCreateForm()
            this.createErrors = {}
            this.successNotification('Customer created')
          })
          .catch((err) => {
            const msg = err.response && err.response.data && err.response.data.error
              ? err.response.data.error
              : 'Failed to create customer'
            // Map uniqueness messages to fields when possible
            if (/email/i.test(msg)) this.$set(this.createErrors, 'email', msg)
            else if (/customer name|company/i.test(msg)) this.$set(this.createErrors, 'company', msg)
            else if (/phone/i.test(msg) && !/mobile/i.test(msg)) this.$set(this.createErrors, 'phone', msg)
            else if (/mobile/i.test(msg)) this.$set(this.createErrors, 'mobile', msg)
            else this.createFormError = msg
          })
          .finally(() => {
            this.createSaving = false
          })
      }
    },
    watch: {
      contact: function () {
        this.fetchSm8Jobs()
      }
    },
    mounted: function () {
      if (this.parent_quote && this.parent_quote.contact && this.parent_quote.contact.id) {
        this.contact = this.parent_quote.contact
      }
    }
  }
</script>

<style scoped>
.customer-modal-body {
  min-height: 120px;
  overflow: visible;
}
.customer-modal-field {
  margin-bottom: 16px;
}
.customer-modal-create-link {
  display: inline-block;
  margin: 0 0 16px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--color-primary);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  text-align: left;
}
.customer-modal-create-link:hover {
  text-decoration: underline;
}
.customer-modal-sm8 {
  margin-top: 8px;
}
.customer-modal-sm8-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.customer-modal-sm8-icon {
  height: 16px;
  width: auto;
}
.customer-modal-sm8-help {
  margin-top: 8px;
  margin-bottom: 0;
  font-size: 13px;
  color: var(--color-text-muted) !important;
}
</style>
